function normalizePhoneNumber(value) {
  if (typeof value === 'object' && value !== null) {
    return {
      ddi: value.ddi || '',
      number: String(value.number || '')
        .replace(/\D/g, '')
        .replace(/^0/, '')
    };
  }

  return {
    ddi: '',
    number: String(value || '')
      .replace(/\D/g, '')
      .replace(/^0/, '')
  };
}

export default normalizePhoneNumber;
